export default function PHP_xml_parser_create_ns() {
  return (
    <div>
      <h1>PHP_xml_parser_create_ns</h1>
    </div>
  );
}
